import React, { useEffect, useState } from "react";
import { AmountFormat } from "components/common/formatter";

const SupplierBalances = ({ supplier, type, balances }) => {
  const [yearToDate, setYearToDate] = useState(undefined);
  const [selectedPeriod, setSelectedPeriod] = useState(undefined);
  const [total, setTotal] = useState(undefined);

  useEffect(() => {
    if (balances && type === "SupplierLedger") {
      setYearToDate(AmountFormat(balances.ytdBalance));
      setSelectedPeriod(AmountFormat(balances.periodBalance));
      setTotal(AmountFormat(balances.balance));
    }
  }, [balances, type]);

  return (
    <div
      className="grid-layout-container"
      style={{ marginBottom: 25, width: "400px" }}
    >
      <table className="balance-table bg-white pb-2">
        <thead className="w-100">
          <tr>
            <th colSpan={2} className="pb-2">
              Balances
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="bt-text">Total</td>
            <td className="bt-value text-end">{supplier && total}</td>
          </tr>
          <tr>
            <td className="bt-text">Year to date</td>
            <td className="bt-value text-end">{supplier && yearToDate}</td>
          </tr>
          <tr>
            <td className="bt-text">Selected period</td>
            <td className="bt-value text-end">{supplier && selectedPeriod}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SupplierBalances;
